import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ENV_CONFIG_TOKEN } from '../shared/config';
import { Call } from './model/call';
import { CallSequence } from './model/call-sequence';
import { Message } from './model/message';
import {
  NotificationCancelRequest,
  NotificationCancelResponse,
} from './model/notification-cancel';
import { NotificationRequest } from './model/notification-request';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  #config = inject(ENV_CONFIG_TOKEN);
  private static notifyUrl: string;
  private static retryUrl: string;
  private static completeUrl: string;
  private static callLogUrl: string;
  private static callSequencesUrl: string;
  private static textLogUrl: string;
  private static callStatesUrl: string;
  private static cancelNotifyUrl: string;

  constructor(private http: HttpClient) {
    NotificationService.notifyUrl = `${this.#config.apiBaseUrl}/notify`;
    NotificationService.cancelNotifyUrl = `${this.#config.apiBaseUrl}/notify/cancel`;
    NotificationService.retryUrl = `${this.#config.apiBaseUrl}/retry`;
    NotificationService.completeUrl = `${this.#config.apiBaseUrl}/on-complete`;
    NotificationService.callLogUrl = `${this.#config.apiBaseUrl}/call`;
    NotificationService.callSequencesUrl = `${this.#config.apiBaseUrl}/call-sequences`;
    NotificationService.textLogUrl = `${this.#config.apiBaseUrl}/message`;
    NotificationService.callStatesUrl = `${this.#config.apiBaseUrl}/call-states`;
  }

  public notify(notificationRequest: NotificationRequest): Observable<CallSequence> {
    return this.http.post<CallSequence>(NotificationService.notifyUrl, notificationRequest);
  }

  public cancelAlert(
    request: NotificationCancelRequest,
  ): Observable<NotificationCancelResponse> {
    return this.http.post<NotificationCancelResponse>(
      NotificationService.cancelNotifyUrl,
      request,
    );
  }

  public retry(patientId: string): Observable<void> {
    return this.http.post<void>(`${NotificationService.retryUrl}?patientId=${patientId}`, '');
  }

  public complete(patientId: string): Observable<void> {
    return this.http.post<void>(`${NotificationService.completeUrl}?patientId=${patientId}`, '');
  }

  public callLogs(patientId: string): Observable<Call[]> {
    return this.http.get<Call[]>(`${NotificationService.callLogUrl}?id=${patientId}`);
  }

  public callSequences(patientId: string): Observable<CallSequence[]> {
    return this.http.get<CallSequence[]>(`${NotificationService.callSequencesUrl}?id=${patientId}`);
  }

  public messageLogs(patientId: string): Observable<Message[]> {
    return this.http.get<Message[]>(`${NotificationService.textLogUrl}?id=${patientId}`);
  }

  public callState(patientId: string): Observable<any[]> {
    return this.http.get<any[]>(`${NotificationService.callStatesUrl}?id=${patientId}`);
  }
}
